import * as auth from './reducers/auth.reducers';
import * as doctor from './reducers/doctor.reducers';
import * as patient from './reducers/patient.reducers';
import {createFeatureSelector} from '@ngrx/store';


export interface AppState {
  authState: auth.State;
  doctorState: doctor.State;
  patientState: patient.State;
}

export const reducers = {
  auth: auth.authReducer,
  doctor: doctor.doctorReducer,
  patient: patient.patientReducer
};

export const selectAuthState = createFeatureSelector<AppState>('auth');
export const selectDoctorState = createFeatureSelector<AppState>('doctor');
export const selectPatientState = createFeatureSelector<AppState>('patient');



